// js
AOS.init();

$(document).ready(function() {

  $(".hamburger").click(function() {
    $(this).toggleClass("is-active");
    $(".box-menu").toggleClass("open");
    $('.wrap-btn-lang').toggleClass("d-none");
    $("header").toggleClass("open-menu");
    $("html").toggleClass("hidden-overflow");

  });

  $(".btn-lang, .btn-lang-2").click(function(e) {
    $(this).toggleClass("show");
    $('.box-menu').toggleClass('btn-lang-active');
    e.stopPropagation();
  });

  $(document).click(function(e) {
    if ($(e.target).is(".btn-lang, .btn-lang-2") === false) {
      $(".btn-lang, .btn-lang-2").removeClass("show");
    }
  });




  // if (!$('.blog, .single-post').length) {
  //   var height = $(document).height();
  //
  //   if ($(this).width() > 992 ) {
  //     if ($('.wrapper-floating').length) {
  //       $('.wrapper-floating').get(0).style.setProperty('height', height - 450 + 'px');
  //     }
  //   }
  //
  //   $(window).resize(function() {
  //     if ($(this).width() > 992 ) {
  //       if ($('.wrapper-floating').length) {
  //         var height = $(document).height();
  //         $('.wrapper-floating').get(0).style.setProperty('height', height - 450 + 'px');
  //       }
  //     } else {
  //       if ($('.wrapper-floating').length) {
  //         $('.wrapper-floating').get(0).style.setProperty('height', '');
  //       }
  //     }
  //   });
  //
  // } else {
  //   setTimeout(function(){
  //
  //     var height = $(document).height();
  //
  //     if ($(this).width() > 992 ) {
  //       $('.wrapper-floating').get(0).style.setProperty('height', height - 450 + 'px');
  //     }
  //
  //     $(window).resize(function() {
  //       if ($(this).width() > 992 ) {
  //         var height = $(document).height();
  //         $('.wrapper-floating').get(0).style.setProperty('height', height - 450 + 'px');
  //       } else {
  //         $('.wrapper-floating').get(0).style.setProperty('height', '');
  //       }
  //     });
  //   }, 500);
  // }



  // Add smooth scrolling to all links
  $("a:not(a[href='#contato'])").on('click', function(event) {
    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== "") {
      // Prevent default anchor click behavior
      event.preventDefault();
      // Store hash
      var hash = this.hash;

      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
      $('html, body').animate({
        scrollTop: $(hash).offset().top
      }, 1000, function(){

        // Add hash (#) to URL when done scrolling (default click behavior)
        // window.location.hash = hash;
      });
    } // End if
  });


  if ($('.go-to-top').length) {
    var scrollTrigger = 1000, // px
    backToTop = function () {
      var scrollTop = $(window).scrollTop();
    };
    backToTop();
    $(window).on('scroll', function () {
      backToTop();
    });
    $('.go-to-top').on('click', function (e) {
      e.preventDefault();
      $('html,body').animate({
        scrollTop: 0
      }, 700);
    });
  }

  if ($(window).width() < 992 ) {
    $('.carousel-news').flickity({
      pageDots: false,
      cellAlign: 'left'
    });

    $('.gallery-mobile').flickity({
      cellSelector: '.gallery-cell',
      pageDots: false,
      prevNextButtons: false,
      cellAlign: 'left',
      // adaptiveHeight: true,
      // resize: true,
      // contain: true,
      // imagesLoaded: true
    });
  }

  if ($(window).width() > 992 ) {
    var container = $('.container').width();
    var total_container_gallery = container - 1;
    $('.wp-block-gallery').css('width', total_container_gallery);

    $(window).resize(function() {
      var container = $('.container').width();
      var total_container_gallery = container - 1;
      $('.wp-block-gallery').css('width', total_container_gallery);
    });

    $('.blocks-gallery-grid').flickity({
      cellSelector: '.blocks-gallery-item',
      pageDots: false,
      // prevNextButtons: false,
      cellAlign: 'left',
      adaptiveHeight: true,
      // resize: true,
      // contain: true,
      // imagesLoaded: true
    });
  } else {
    $('.blocks-gallery-grid').flickity({
      cellSelector: '.blocks-gallery-item',
      pageDots: false,
      prevNextButtons: false,
      cellAlign: 'left',
      adaptiveHeight: true,
    });
  }



  var $temp = $("<input>");
  var $url = $(location).attr('href');

  $('.copy-clipboard').click(function() {
    $(".copy-clipboard").append($temp);
    $temp.val($url).select();
    document.execCommand("copy");
    $temp.remove();
    $(".alert-copy").removeClass("hide");
    setTimeout(function(){
      $(".alert-copy").addClass("hide");
    }, 800);
  });


  $(window).scroll(function() {
    var scroll = $(window).scrollTop();

    if (scroll >= 200) {
      $(".go-to-top").addClass("show");
    } else {
      $(".go-to-top").removeClass("show");
    }
  });

  //
  // $('.copy-clipboard').click(function() {
  //   var copyText = document.getElementById("copy-clipboard");
  //   copyText.select();
  //   copyText.setSelectionRange(0, 99999)
  //   document.execCommand("copy");
  //   alert("Copied the text: " + copyText.value);
  // });







  $("input, textarea, select" ).change(function() {
    $(this).siblings().remove('.wpcf7-not-valid-tip');
  });

  $(".wpcf7-submit").click(function() {
    //IF THE SUBMIT IS PRESSED

    if (window.location.href.indexOf("/en/") > -1) {
      $('input[type=submit]').val('Sending...');
    }
    else {
      $('input[type=submit]').val('Enviando...');
    }


    // $(document).ajaxComplete(function() {
    //   if (!$(".wpcf7 form").hasClass("invalid")) {
    //     $('input[type=submit]').val('Enviar');
    //     $('.form-msg').text($('.wpcf7-response-output').text());
    //   }
    // });
  });




  $('.btn-next, .btn-prev').click(function(){
    setTimeout(function(){
      $('body').addClass('modal-open');
    }, 500);

  });



  $('#nossos-projetos .list li').each(function( index ) {
    index += 1;
    $(this).hover(function(){
      $('.list-hover-item-'+index).addClass('hover');
      $('.list-hover-item-'+index).siblings().removeClass('hover');
    });
  });

  $('#noticias .list li').each(function( index ) {
    index += 1;
    $(this).hover(function(){
      $('.list-hover-item-'+index).addClass('hover');
      $('.list-hover-item-'+index).siblings().removeClass('hover');
    });
  });

  if ( $('#anchor-color').length && $(window).width() > 991 ) {

    $.fn.isOnScreen = function(){

      var win = $(window);

      var viewport = {
        top : win.scrollTop(),
        left : win.scrollLeft()
      };
      viewport.right = viewport.left + win.width();
      viewport.bottom = viewport.top + win.height();

      var bounds = this.offset();
      bounds.right = bounds.left + this.outerWidth();
      bounds.bottom = bounds.top + this.outerHeight();

      return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));

    };

    $(window).scroll(function() {
      if ($('#anchor-color').isOnScreen() == true) {
        $('.rtl').css('color','black');
      } else {
        $('.rtl').css('color','white');
      }

    });
  }


  $('input, textarea').focus(function(){
    $(this).parents('.form-group').addClass('focused');
  });

  $('input, textarea').blur(function(){
    var inputValue = $(this).val();
    if ( inputValue == "" ) {
      $(this).parents('.form-group').removeClass('focused');
    }
  });



  //processos animation

  if ( $('#processos').length ) {
    $(window).scroll(function() {

      // ETAPA 1

      if ( $('#etapa-1').isOnScreen() == true && $('#etapa-2, #etapa-3, #etapa-4, #etapa-5').isOnScreen() == false ) {
        $('.circle.item-1').removeClass('stopped').addClass('show');
      }
      else if ( $('#etapa-1').isOnScreen() == false && $('#etapa-2, #etapa-3, #etapa-4, #etapa-5').isOnScreen() == true ) {
        $('.circle.item-1').removeClass('show').addClass('stopped');
      }
      else if ( $('#etapa-1').isOnScreen() == true && $('#etapa-2').isOnScreen() == true ) {
        $('.circle.item-1').removeClass('show').addClass('stopped');
      }
      else if ( $('#etapa-1').isOnScreen() == false && $('#etapa-2').isOnScreen() == false && $('#etapa-3').isOnScreen() == false && $('#etapa-4').isOnScreen() == false && $('#etapa-5').isOnScreen() == false  ) {
        $('.circle.item-1').removeClass('show').removeClass('stopped');
      }

      // ETAPA 2

      if ( $('#etapa-2').isOnScreen() == true && $('#etapa-3, #etapa-4, #etapa-5').isOnScreen() == false ) {
        $('.circle.item-2').removeClass('stopped').addClass('show');
      }
      else if ( $('#etapa-2').isOnScreen() == false && $('#etapa-3, #etapa-4, #etapa-5').isOnScreen() == true ) {
        $('.circle.item-2').removeClass('show').addClass('stopped');
      }
      else if ( $('#etapa-2').isOnScreen() == true && $('#etapa-1').isOnScreen() == true ) {
        $('.circle.item-2').removeClass('stopped').addClass('show');
      }
      else if ( $('#etapa-2').isOnScreen() == true && $('#etapa-3').isOnScreen() == true ) {
        $('.circle.item-2').removeClass('show').addClass('stopped');
      }
      else if ( $('#etapa-2').isOnScreen() == false && $('#etapa-3').isOnScreen() == false && $('#etapa-4').isOnScreen() == false && $('#etapa-5').isOnScreen() == false  ) {
        $('.circle.item-2').removeClass('show').removeClass('stopped');
      }



      // ETAPA 3

      if ( $('#etapa-3').isOnScreen() == true && $('#etapa-4, #etapa-5').isOnScreen() == false ) {
        $('.circle.item-3').removeClass('stopped').addClass('show');
      }
      else if ( $('#etapa-3').isOnScreen() == false && $('#etapa-4, #etapa-5').isOnScreen() == true ) {
        $('.circle.item-3').removeClass('show').addClass('stopped');
      }
      else if ( $('#etapa-3').isOnScreen() == true && $('#etapa-2').isOnScreen() == true ) {
        $('.circle.item-3').removeClass('stopped').addClass('show');
      }
      else if ( $('#etapa-3').isOnScreen() == true && $('#etapa-4').isOnScreen() == true ) {
        $('.circle.item-3').removeClass('show').addClass('stopped');
      }
      else if ( $('#etapa-3').isOnScreen() == false  && $('#etapa-4').isOnScreen() == false && $('#etapa-5').isOnScreen() == false  ) {
        $('.circle.item-3').removeClass('show').removeClass('stopped');
      }

      // ETAPA 4

      if ( $('#etapa-4').isOnScreen() == true && $('#etapa-5').isOnScreen() == false ) {
        $('.circle.item-4').removeClass('stopped').addClass('show');
      }
      else if ( $('#etapa-4').isOnScreen() == false && $('#etapa-5').isOnScreen() == true ) {
        $('.circle.item-4').removeClass('show').addClass('stopped');
      }
      else if ( $('#etapa-4').isOnScreen() == true && $('#etapa-3').isOnScreen() == true ) {
        $('.circle.item-4').removeClass('stopped').addClass('show');
      }
      else if ( $('#etapa-4').isOnScreen() == true && $('#etapa-5').isOnScreen() == true ) {
        $('.circle.item-4').removeClass('show').addClass('stopped');
      }
      else if ( $('#etapa-4').isOnScreen() == false  && $('#etapa-5').isOnScreen() == false ) {
        $('.circle.item-4').removeClass('show').removeClass('stopped');
      }



      // ETAPA 5

      if ( $('#etapa-5').isOnScreen() == true ) {
        $('.losango, .losango-p').addClass('show');
        $('.circle.item-4').removeClass('show').addClass('stopped');
      }
      else if ( $('#etapa-5').isOnScreen() == true && $('#etapa-4').isOnScreen() == true ) {
        $('.losango, .losango-p').addClass('show');
      } else {
        $('.losango, .losango-p').removeClass('show');
      }


    });

  }

  if( $('.number-counter').length) {

    $('.number-counter').counterUp({
      delay: 10,
      time: 2000
    });

  }

  //   const el = document.querySelector( '.number-counter' )
  //
  // // Start counting, do this on DOM ready or with Waypoints.
  // counterUp( el, {
  //     duration: 1000,
  //     delay: 16,
  // } );




  // init Isotope
  var $grid = $('.post-type-archive-projetos #nossos-projetos .list').isotope({
    itemSelector: '.element-item',
    layoutMode: 'fitRows'
  });

  var $grid2 = $('.all-posts').isotope({
    itemSelector: 'article',
    layoutMode: 'fitRows'
  });

  // filter functions
  var filterFns = {};

  // bind filter button click
  $('.post-type-archive-projetos .tag').on( 'click', function() {
    var filterValue = $( this ).attr('data-filter');
    $(this).addClass('active').siblings().removeClass('active');
    // use filterFn if matches value
    filterValue = filterFns[ filterValue ] || filterValue;
    $grid.isotope({ filter: filterValue });
    $grid2.isotope({ filter: filterValue });

  });


  // change is-checked class on buttons
  $('.post-type-archive-projetos .tag').each( function( i, buttonGroup ) {
    var $buttonGroup = $( buttonGroup );
    $buttonGroup.on( 'click', 'button', function() {
      $buttonGroup.find('.is-checked').removeClass('is-checked');
      $( this ).addClass('is-checked');
    });
  });

  if (!$('#diga-oi').length) {
    $('.link-to-contact').removeAttr("href");
    $('.link-to-contact').click(function(){
      $('#modal-contato').modal('show');
    });
  }

  $('.link-to-contact-modal a, .link-to-contact-modal').removeAttr("href");
  // $('.link-to-contact-modal, a[href="#contato"]').click(function(){
  $('.link-to-contact-modal').click(function(){
    $('#modal-contato').modal('show');
  });

  $('#modal-contato').on('show.bs.modal', function (event) {
    $('html').addClass('overflow-hidden');
  });
  $('#modal-contato').on('hide.bs.modal', function (event) {
    $('html').removeClass('overflow-hidden');
  });



  $(window).scroll(function() {
    var scroll = $(window).scrollTop();
    if (scroll >= 100) {
      $('header').addClass("active");
    } else {
      $('header').removeClass("active");
    }
  });

  $(".btn-lang .lang-item:not(.current-lang)").wrapAll( "<div class='wrap-options' />");
  $(".btn-lang-2 .lang-item:not(.current-lang)").wrapAll( "<div class='wrap-options' />");



  var swiper = new Swiper(".mySwiper", {
    slidesPerView: "auto",
    centeredSlides: true,
    updateOnWindowResize: true,
    loop: true,
    spaceBetween: 30,
    speed: 5000,
    direction: 'horizontal',
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });


  var swiper_clientes = new Swiper(".clientes", {
    slidesPerView: "auto",
    centeredSlides: true,
    updateOnWindowResize: true,
    loop: true,
    spaceBetween: 60,
    speed: 5000,
    direction: 'horizontal',
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });

  $(window).on( "load", function() {
    swiper.autoplay.stop();
    swiper_clientes.autoplay.stop();
  } );

  if($('.home').length) {
    $(window).scroll(function() {
      scroll_page = $(this).scrollTop();
      section_h = $('.home .first-sec').innerHeight() * 0.28;
      section_h2 = ($('.home .wrap-mosaico').offset().top - $(window).scrollTop()) + ($('.home .wrap-mosaico').innerHeight() * 0.65);

      console.log(scroll_page);
      console.log(section_h2);


      if(scroll_page >= section_h) {
        swiper.autoplay.start();
      } else {
        swiper.autoplay.stop();
      }

      if(section_h2 <= 0) {
        swiper_clientes.autoplay.start();
      } else {
        swiper_clientes.autoplay.stop();
      }


    });
  }

if ($(window).width() > 768) {
  $('.wrap-mosaico').css('margin-top', '-'+$('#texto-height').height()+'px');
}

  var swiper2 = new Swiper(".depoimentos", {
    slidesPerView: 1,
    centeredSlides: true,
    loop: true,
    autoplay: {
      delay: 8000,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });


  $('.btn.go-back').click(function(){
    $('.form-msg-lp').removeClass('show');
  });

  var maskBehavior = function (val) {
   return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
  },
  options = {onKeyPress: function(val, e, field, options) {
   field.mask(maskBehavior.apply({}, arguments), options);
   }
  };

  $('input[type="tel"]').mask(maskBehavior, options);


});



// document.addEventListener( 'wpcf7submit', function( event ) {
//   $('input[type=submit]').val('Enviando...');
// }, false );

document.addEventListener( 'wpcf7mailsent', function( event ) {
  if ( event.detail.contactFormId == '373') {
    $('input[type=submit]').val('Send message');
  }
  if ( event.detail.contactFormId == '374') {
    $('input[type=submit]').val('Enviar mensaje');
  }
  if ( event.detail.contactFormId == '23') {
      $('input[type=submit]').val('Enviar mensagem');
  }
  $('.form-group').removeClass('focused');
  $('.form-msg').addClass('show');
  setTimeout(function(){
    var txt_msg = $('.wpcf7-response-output').text();
    $('.form-msg').text(txt_msg);
  }, 200);
  setTimeout(function(){
    $('.form-msg').removeClass('show');
  }, 4000);

  if ( event.detail.contactFormId == '4347'  || event.detail.contactFormId == '4348' || event.detail.contactFormId == '4349' ) {
    $('.form-msg-lp').addClass('show');
  }

}, false );


document.addEventListener( 'wpcf7invalid', function( event ) {
  if ( event.detail.contactFormId == '373') {
    $('input[type=submit]').val('Send message');
  }
  if ( event.detail.contactFormId == '374') {
    $('input[type=submit]').val('Enviar mensaje');
  }
  if ( event.detail.contactFormId == '23') {
      $('input[type=submit]').val('Enviar mensagem');
  }


  if ( event.detail.contactFormId == '4348') {
    $('input[type=submit]').val('Send');
  }
  if ( event.detail.contactFormId == '4347' || event.detail.contactFormId == '4349') {
    $('input[type=submit]').val('Enviar');
  }

  // setTimeout(function(){
  //   var txt_msg = $('.wpcf7-response-output').text();
  //   $('.form-msg').text(txt_msg);
  // }, 200);
}, false );

jQuery(document).ready(function(){
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const filtro = urlParams.get('filter');
  jQuery('[data-filter="'+filtro+'"]').click();
  jQuery('.tag[data-filter="'+filtro+'"]').addClass('active');
});
